import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import * as moment from 'moment';
import * as T_T from 'cryface';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../../utils/axios.promise';

@Component
export default class PresentationListRow extends Vue {
    public title: string = 'PresentationListRow';
    public config = new CommonConfig();

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public formatDate(dt: string) {
        return moment(dt).format(this.config.dateTimeFormat);
    }

    public detail(id: any) {
        this.$router.push(`/listing-presentation/stage/${id}`);
    }

    public async del(id: any) {
        const apihost = this.config.apiHost;
        try {
            const fetched = await AxiosPromise.axioxDelete(`${apihost}/agent/listing/presentation//deletion?id=${id}`);
            // const fetched = await AxiosPromise.axioxDelete(`http://192.168.0.40:9528/radar-api/agent/listing/presentation//deletion?id=${id}`);
            this.$store.commit('lpListReload');
        } catch (e) {
            console.log(e);
        }
    }
}
